export async function parseCsvIds(file: File): Promise<string[]> {
  const text = await file.text();

  return text
    .split('\n')
    .map((r) => r.trim())
    .filter(Boolean);
}
